import type { AdminRole } from "./types";

export type Permission =
  | "read"
  | "editLicense"
  | "issueKeys"
  | "exportIntegrationGuide"
  | "revokeLicense"
  | "deactivateActivation"
  | "revokeProductKey"
  | "replaceProductKey"
  | "manageProductStatus"
  | "manageFeatureCatalog"
  | "createRecords";

const permissions: Record<Permission, AdminRole[]> = {
  read: ["Viewer", "Support", "License Manager", "Security Admin"],
  editLicense: ["License Manager", "Security Admin"],
  issueKeys: ["License Manager", "Security Admin"],
  exportIntegrationGuide: ["License Manager", "Security Admin"],
  revokeLicense: ["Security Admin"],
  deactivateActivation: ["Support", "License Manager", "Security Admin"],
  revokeProductKey: ["Security Admin"],
  replaceProductKey: ["License Manager", "Security Admin"],
  manageProductStatus: ["Security Admin"],
  manageFeatureCatalog: ["License Manager", "Security Admin"],
  createRecords: ["License Manager", "Security Admin"],
};

export type AdminRoleInput = AdminRole | readonly AdminRole[] | undefined;

export function can(role: AdminRoleInput, permission: Permission) {
  const roles = role ? (Array.isArray(role) ? role : [role]) : [];
  return roles.some((candidate) => permissions[permission].includes(candidate));
}

export function requiredRole(permission: Permission) {
  switch (permission) {
    case "read":
      return "Viewer";
    case "editLicense":
    case "issueKeys":
    case "exportIntegrationGuide":
      return "License Manager";
    case "revokeLicense":
    case "revokeProductKey":
    case "manageProductStatus":
      return "Security Admin";
    case "deactivateActivation":
      return "Support";
    case "replaceProductKey":
      return "License Manager";
    case "manageFeatureCatalog":
      return "License Manager";
    case "createRecords":
      return "License Manager";
  }
}
